export enum StorefrontWidgetPlacementType {
  Cart = "cart",
  Pdp = "pdp",
}
